import { useState } from 'react';

const CallUs = ({ src, text, phoneNumber, alt, maxHeight }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [displayText, setDisplayText] = useState(text);

  const handleClick = (e) => {
    if (!isClicked) {
      e.preventDefault();
      setDisplayText(phoneNumber);
      setIsClicked(true);
    }
    // If already clicked, let the tel: link work normally (open phone app)
  };

  return (
    <a 
      href={isClicked ? `tel:${phoneNumber}` : "#"} 
      className="phone-link d-flex align-items-center" 
      onClick={handleClick}
    >
      <img
        src={src}
        alt={alt || ''}
        style={{ maxHeight: maxHeight || '100%' }}
        className="img-fluid"
      />
      <span className="ms-2">{displayText}</span>
    </a>
  );
};

export default CallUs;
